import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { studentHeadCells, subjectHeadCells } from '../../../../../shared/data/headCells'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { ExportIcon, ImportIcon } from '../../../../../assets/icons'
import {
  setIsEdit,
  setOpenAddSubject,
  setOpenExportModal,
  setOpenImport,
  setOpenTransportModal,
} from '../../../../../redux/globalSlice'
import classes from './Student.module.css'
import DashboardCard from '../../Dashboard/component/Card'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import SubjectModal from './SubjectModal/SubjectModal'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
const Subject = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [page, setPage] = useState(1)
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const dispatch = useDispatch()
  const open = useSelector((state) => state.global.openAddSubject)
  // console.log('----customRole',customRole);

  const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const [schoolName, setSchoolName] = React.useState('')
  // console.log('-----schoolName', schoolName)

  const {
    data: subjectRow,
    count,
    refetch,
  } = useGlobal({
    userUrl: `${urls.SUBJECT}?school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&keyword=${search}`,
  })

  // console.log('---subjectRow',subjectRow);

  const [feeStatus, setFeeStatus] = useState('')
  const [gradeValue, setGradeVal] = useState('')
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const { data: searchstudent, count: searchcount } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${selectedGrade}&fee_status=${feeStatus}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  // })

  // console.log('---grades', grades)

  // const [update, setUpdate] = useState(false)
  // const [detail, setDetail] = useState(false)

  const rowData =  subjectRow

  const handleOpen = () => {
    dispatch(setOpenAddSubject(true))
  }



  const no_data_msg =
    customRole == 'Admin'
      ? 'No Subject Found'
      : schoolName
        ? 'Select school to see Students'
        : 'Select school to see Students'

  const pagecount = search ? searchcount : count

  const handleUpdate = () => {
    dispatch(setIsEdit(true))
    dispatch(setOpenAddSubject(true))
  }

  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with filters
      let filename = 'Subjects';
      
      if (schoolName) {
        const school = schoolList?.find(s => s.school_id === schoolName);
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`;
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`;
      }
      
      if (selectedGrade) {
        filename += `_Grade_${selectedGrade}`;
      }
      
      // Add date
      const date = new Date().toISOString().split('T')[0];
      filename += `_${date}`;
      
      downloadCSV(rowData, filename);
    } else {
      alert('No data to export');
    }
  }


  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Subject'} subtitle={'Class / Subject'} />
      {/* <div className={classes.analyticsContainer}>
        {analyticsData.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} />
        ))}
      </div> */}
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => setSchoolName(selectedOption)}
              setPage={setPage}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        width={'fit-content'}
        transport={true}
        search={search}
        setSearchItem={setSearch}
        setPage={setPage}
      >
        {/* <FilterStudent
          feeStatus={feeStatus}
          setFeeStatus={setFeeStatus}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
        /> */}

        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
      </ToolbarComponent>
      {rowData?.length === 0 ? (
        no_data_msg
      ) : (
        <DataTable
          headCells={subjectHeadCells}
          rowData={rowData}
          subject
          pages
          pageFee={page}
          noDataMsg={no_data_msg}
          setPageFee={setPage}
          school={false}
          search={search}
          setUpdate={handleUpdate}
          pageCount={pagecount}
          refetch={refetch}
          // count={count}
          // handleDetailOpen={() => setDetail(true)}
        />
      )}
      {open && <SubjectModal open={open} school_id={userSchoolId} refetch={refetch} />}
    </div>
  )
}

export default Subject
